import { render, staticRenderFns } from "./YA_footer.vue?vue&type=template&id=0c4a7508&scoped=true"
import script from "./YA_footer.vue?vue&type=script&lang=js"
export * from "./YA_footer.vue?vue&type=script&lang=js"
import style0 from "./YA_footer.vue?vue&type=style&index=0&id=0c4a7508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a7508",
  null
  
)

export default component.exports